import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  akomiLoginPage: {
    height: '100vh',
    width: '100%',
    display: 'flex',
  },
  akomiLoginLogo: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
  },
  akomiLoginForm: {
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
